/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_PlanInputs */

const fr_membership_section_plan = /** @type {(inputs: Membership_Section_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palier`)
};

/**

* @param {Membership_Section_PlanInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_plan = /** @type {((inputs?: Membership_Section_PlanInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_PlanInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_plan(inputs)
});